"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Crud = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var Route_1 = require("../nav/route/Route");
function Crud(_a) {
    var name = _a.name, listComponent = _a.listComponent, readComponent = _a.readComponent, _b = _a.routes, routes = _b === void 0 ? [] : _b, _c = _a.privateRoute, privateRoute = _c === void 0 ? true : _c, layout = _a.layout;
    var match = react_router_dom_1.useRouteMatch();
    if (!match) {
        return null;
    }
    var idParam = ":" + (name.charAt(0).toLowerCase() + name.slice(1)) + "Id";
    // Add CRUD path prefix to given routes
    routes = routes.map(function (route) {
        route.path = match.path + "/" + idParam + "/" + route.path;
        return route;
    });
    if (listComponent) {
        routes.push({
            exact: true,
            path: match.path,
            component: listComponent,
            privateRoute: privateRoute,
        });
    }
    if (readComponent) {
        routes.push({
            exact: true,
            path: match.path + "/" + idParam,
            component: readComponent,
            privateRoute: privateRoute,
        });
    }
    return (react_1.default.createElement(react_router_dom_1.Switch, null, routes.map(function (route) { return Route_1.renderRoute(tslib_1.__assign({ layout: layout }, route)); })));
}
exports.Crud = Crud;
//# sourceMappingURL=Crud.js.map